import React, { useEffect, useRef, useState } from 'react';

import { SearchInput } from './ui';

/**
 * Debounced quick-search box.
 *
 * Thin wrapper around the shared <SearchInput> (components/ui/SearchInput.jsx) —
 * it only adds the debounce. All appearance, sizing and casing rules live in
 * SearchInput so every search bar in the product looks the same; don't restyle
 * this per page.
 *
 * Placeholders must be sentence case or Title Case — this project doesn't use
 * ALL-CAPS text.
 */
const QuickFilter = ({
    className = '',
    onUpdate,
    delay = 500,
    placeholder = "",
    size = 'lg',
    auto = false,
    ...rest
}) => {
    const [ value, setValue ] = useState('')
    const timeoutRef = useRef()

    // Don't leave a pending debounce running after unmount — it would fire
    // onUpdate on a gone component (the previous implementation did).
    useEffect(() => () => clearTimeout(timeoutRef.current), [])

    const onChange = (e) => {
        const newValue = e.target.value
        setValue(newValue)

        clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => onUpdate(newValue), delay)
    }

    const onClear = () => {
        setValue('')
        clearTimeout(timeoutRef.current)
        onUpdate('')
    }

    return (
        <SearchInput
            className={`quick-search ${className}`.trim()}
            size={size}
            auto={auto}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onClear={onClear}
            {...rest}
        />
    )
}

export default QuickFilter
